/**
 * Created by ren on 01/06/2017.
 */


/**
 * Saga Types for Fetch List Data
 * @type {string}
 */
export const FETCH_LIST_DATA_ARRAY_INPROGRESS = 'FETCH_LIST_DATA_ARRAY_INPROGRESS';
export const FETCH_LIST_DATA_ARRAY_DONE = 'FETCH_LIST_DATA_ARRAY_DONE';
export const FETCH_LIST_DATA_ARRAY_ERROR = 'FETCH_LIST_DATA_ARRAY_ERROR';

/**
 * Saga Types for Fetch Data By ID
 * @type {string}
 */
export const FETCH_DATA_BY_ID_INPROGRESS = 'FETCH_DATA_BY_ID_INPROGRESS';
export const FETCH_DATA_BY_ID_DONE = 'FETCH_DATA_BY_ID_DONE';
export const FETCH_DATA_BY_ID_ERROR = 'FETCH_DATA_BY_ID_ERROR';

/**
 * Saga Types for Save Record
 * @type {string}
 */
export const SAVE_RECORD_INPROGRESS = 'SAVE_RECORD_INPROGRESS';
export const SAVE_RECORD_DONE = 'SAVE_RECORD_DONE';
export const SAVE_RECORD_ERROR = 'SAVE_RECORD_ERROR';
export const CLEAR_SAVE_RECORD = 'CLEAR_SAVE_RECORD';

/**
 * Saga Types for Save As Record
 * @type {string}
 */
export const SAVE_AS_RECORD_INPROGRESS = 'SAVE_AS_RECORD_INPROGRESS';
export const SAVE_AS_RECORD_DONE = 'SAVE_AS_RECORD_DONE';
export const SAVE_AS_RECORD_ERROR = 'SAVE_AS_RECORD_ERROR';

/**
 * Saga Types for Preferences
 * @type {string}
 */
export const SAVE_PREFERENCE = 'SAVE_PREFERENCE';
export const FETCH_PREFERENCE_BY_ID = 'FETCH_PREFERENCE_BY_ID';
export const FETCH_LIST_PREFERENCE = 'FETCH_LIST_PREFERENCE';
export const FETCH_ALL_PREFERENCE = 'FETCH_ALL_PREFERENCE';
export const FETCH_PREFERENCES_WITH_FILTER = 'FETCH_PREFERENCES_WITH_FILTER';

export const FETCH_PREFERENCES_SETTINGS = 'FETCH_PREFERENCES_SETTINGS';


export const GET_PRICEBOOK_TAX_CODE = 'GET_PRICEBOOK_TAX_CODE';

/**
 * Saga Type for language
 * @type {string}
 */
export const DISPLAY_USER_LOCALE = 'DISPLAY_USER_LOCALE';
export const SET_TRANSLATION_MESSAGE = 'SET_TRANSLATION_MESSAGE';

/**
 * Saga Types for Shift Type
 * @type {string}
 */
export const FETCH_LIST_SHIFT_TYPE = 'FETCH_LIST_SHIFT_TYPE';
export const SAVE_SHIFT_TYPE = 'SAVE_SHIFT_TYPE';
export const DELETE_SHIFT_TYPE = 'DELETE_SHIFT_TYPE';
export const FETCH_SHIFT_TYPE_BY_ID = 'FETCH_SHIFT_TYPE_BY_ID';


/**
 * Saga Types for Item Number Type
 * @type {string}
 */
 export const FETCH_LIST_ITEM_NUMBER_TYPE = 'FETCH_LIST_ITEM_NUMBER_TYPE';
 export const SAVE_ITEM_NUMBER_TYPE = 'SAVE_ITEM_NUMBER_TYPE';
 export const DELETE_ITEM_NUMBER_TYPE = 'DELETE_ITEM_NUMBER_TYPE';
 export const FETCH_ITEM_NUMBER_TYPE_BY_ID = 'FETCH_ITEM_NUMBER_TYPE_BY_ID';

/**
 * Saga Type for Inventory Transfer
 * @type {string}
 */
export const FETCH_INVENTORY_TRANSFER_BY_ID = 'FETCH_INVENTORY_TRANSFER_BY_ID';
export const SAVE_INVENTORY_TRANSFER = 'SAVE_INVENTORY_TRANSFER';
export const FETCH_LIST_INVENTORY_TRANSFER = 'FETCH_LIST_INVENTORY_TRANSFER';
export const GET_INVENTORY_TRANSFER = 'GET_INVENTORY_TRANSFER';
export const INITIALIZE_MASS_INVENTORY_TRANSFER = 'INITIALIZE_MASS_INVENTORY_TRANSFER';
export const GET_INVENTORY_TRANSFER_LINE_ITEM_LOCATION = 'GET_INVENTORY_TRANSFER_LINE_ITEM_LOCATION';
export const GET_ALL_INVENTORY_TRANSFER_LINES_ITEM_LOCATION = 'GET_ALL_INVENTORY_TRANSFER_LINES_ITEM_LOCATION';
export const GET_PREFERENCES_BY_FROM_LOCATION = 'GET_PREFERENCES_BY_FROM_LOCATION';
export const SELECT_LINES_BY_STATUS = 'SELECT_LINES_BY_STATUS';
export const SET_LINES_RECEIVED_QUANTITY = 'SET_LINES_RECEIVED_QUANTITY';
export const EXPORT_EMAIL_INVENTORY_TRANSFER = 'EXPORT_EMAIL_INVENTORY_TRANSFER';

/**
 * Saga Type for Dropdowns
 * @type {string}
 */
export const FETCH_DROPDOWN = 'FETCH_DROPDOWN';
export const REFRESH_DROPDOWN = 'REFRESH_DROPDOWN';

/**
 * Saga Type for Reports
 */
export const FETCH_REPORT_BY_ID = 'FETCH_REPORT_BY_ID';
export const SHOW_REPORT_FILTER = 'SHOW_REPORT_FILTER';
export const OPEN_REPORT_FILTER = 'OPEN_REPORT_FILTER';
export const SET_DATEPICKER_DIALOG_DATES = 'SET_DATEPICKER_DIALOG_DATES';
export const REFRESH_DATEPICKER_DISPLAY = 'REFRESH_DATEPICKER_DISPLAY';
export const FETCH_REPORT_ALL = 'FETCH_REPORT_ALL';
export const FETCH_REPORT_SALETOTALS = 'FETCH_REPORT_SALETOTALS';
export const SHOW_REPORT_DONE = 'SHOW_REPORT_DONE';
export const SHOW_REPORT_INPROGRESS = 'SHOW_REPORT_INPROGRESS';
export const SHOW_REPORT_ERROR = 'SHOW_REPORT_ERROR';
export const SHOW_REPORT_BY_ID_DONE = 'SHOW_REPORT_BY_ID_DONE';
export const SHOW_REPORT_BY_ID_INPROGRESS = 'SHOW_REPORT_BY_ID_INPROGRESS';
export const SHOW_REPORT_BY_ID_ERROR = 'SHOW_REPORT_BY_ID_ERROR';

export const EXECUTE_REPORT = 'EXECUTE_REPORT';
export const EXPORT_REPORT = 'EXPORT_REPORT';
export const EXPORTING_REPORT = 'EXPORTING_REPORT';
export const DONE_EXPORT_REPORT = 'DONE_EXPORT_REPORT';
export const ERROR_EXPORTING_REPORT = 'ERROR_EXPORTING_REPORT'

export const SHOW_ALL_REPORTS_DONE = 'SHOW_ALL_REPORTS_DONE';
export const SHOW_ALL_REPORTS_INPROGRESS = 'SHOW_ALL_REPORTS_INPROGRESS';
export const SHOW_ALL_REPORTS_ERROR = 'SHOW_ALL_REPORTS_ERROR';

/** Dashboards */
export const ADD_PORTLET = 'ADD_PORTLET';
export const CHANGE_DASHBOARD_AUTO_REFRESH = 'CHANGE_DASHBOARD_AUTO_REFRESH';
export const CHANGE_DASHBOARD_DATA = 'CHANGE_DASHBOARD_DATA';
export const CHANGE_DASHBOARD_LAYOUT = 'CHANGE_DASHBOARD_LAYOUT';
export const CHANGE_PORTLET_AUTO_REFRESH = 'CHANGE_PORTLET_AUTO_REFRESH';
export const CHANGE_PORTLET_CRITERIA = 'CHANGE_PORTLET_CRITERIA';
export const CHANGE_PORTLET_VIEW = 'CHANGE_PORTLET_VIEW';
export const CLEAR_FETCH_DASHBOARD_LIST_ERROR = 'CLEAR_FETCH_DASHBOARD_LIST_ERROR';
export const CLEAR_PORTLET_ERROR = 'CLEAR_PORTLET_ERROR';
export const CREATE_DASHBOARD = 'CREATE_DASHBOARD';
export const CREATE_DASHBOARD_DONE = 'CREATE_DASHBOARD_DONE';
export const DELETE_DASHBOARD = 'DELETE_DASHBOARD';
export const DELETE_DASHBOARD_DONE = 'DELETE_DASHBOARD_DONE';
export const DELETE_DASHBOARD_ERROR = 'DELETE_DASHBOARD_ERROR';
export const DELETE_PORTLET = 'DELETE_PORTLET';
export const DELETE_PORTLET_META = 'DELETE_PORTLET_META';
export const DRILLDOWN_TO_REPORT = 'DRILLDOWN_TO_REPORT';
export const EDIT_DASHBOARD = 'EDIT_DASHBOARD';
export const EXECUTE_ALL_DASHBOARD_PORTLET = 'EXECUTE_ALL_DASHBOARD_PORTLET';
export const EXECUTE_DASHBOARD_PORTLET = 'EXECUTE_DASHBOARD_PORTLET';
export const FETCH_DASHBOARD = 'FETCH_DASHBOARD';
export const FETCH_DASHBOARD_DONE = 'FETCH_DASHBOARD_DONE';
export const FETCH_DASHBOARD_ERROR = 'FETCH_DASHBOARD_ERROR';
export const FETCH_DASHBOARD_INPROGRESS = 'FETCH_DASHBOARD_INPROGRESS';
export const FETCH_DASHBOARD_LIST = 'FETCH_DASHBOARD_LIST';
export const FETCH_DASHBOARD_LIST_DONE = 'FETCH_DASHBOARD_LIST_DONE';
export const FETCH_DASHBOARD_LIST_ERROR = 'FETCH_DASHBOARD_LIST_ERROR';
export const FETCH_DASHBOARD_PORTLET_DONE = 'FETCH_DASHBOARD_PORTLET_DONE';
export const FETCH_DASHBOARD_PORTLET_ERROR = 'FETCH_DASHBOARD_PORTLET_ERROR';
export const FETCH_DASHBOARD_PORTLET_INPROGRESS = 'FETCH_DASHBOARD_PORTLET_INPROGRESS';
export const INIT_DASHBOARD_PORTLET_META = 'INIT_DASHBOARD_PORTLET_META';
export const MOVE_PORTLET = 'MOVE_PORTLET';
export const RESET_EDIT_DASHBOARD = 'RESET_EDIT_DASHBOARD';
export const RESET_EDIT_DASHBOARD_DONE = 'RESET_EDIT_DASHBOARD_DONE';
export const RESYNC_PORTLET = 'RESYNC_PORTLET';
export const SAVE_DASHBOARD = 'SAVE_DASHBOARD';
export const SAVE_DASHBOARD_DONE = 'SAVE_DASHBOARD_DONE';
export const SAVE_DASHBOARD_ERROR = 'SAVE_DASHBOARD_ERROR';
export const SAVE_DASHBOARD_INPROGRESS = 'SAVE_DASHBOARD_INPROGRESS';
export const SET_DASHBOARD = 'SET_DASHBOARD';
export const SET_DASHBOARD_DONE = 'SET_DASHBOARD_DONE';
export const SET_DASHBOARD_ERROR = 'SET_DASHBOARD_ERROR';
export const SETUP_PORTLET = 'SETUP_PORTLET';
export const SETUP_PORTLET_DONE = 'SETUP_PORTLET_DONE';
export const SETUP_PORTLET_ERROR = 'SETUP_PORTLET_ERROR';
export const START_POUCH_LISTENER = 'START_POUCH_LISTENER';

/** Integration */
export const SAVE_INTEGRATION_APP = 'SAVE_INTEGRATION_APP';
export const FETCH_LIST_INTEGRATION_APP = 'FETCH_LIST_INTEGRATION_APP';
export const FETCH_INTEGRATION_APP_FOR_EDIT = 'FETCH_INTEGRATION_APP_FOR_EDIT';
export const DELETE_INTEGRATION_APP = 'DELETE_INTEGRATION_APP';
export const DELETE_INTEGRATION_APP_FROM_LIST = 'DELETE_INTEGRATION_APP_FROM_LIST';
export const REGENERATE_INTEGRATION_APP_SECRET = 'REGENERATE_INTEGRATION_APP_SECRET';

/** CSV */
export const START_CSV_IMPORT = 'START_CSV_IMPORT';
export const STOP_CSV_IMPORT = 'STOP_CSV_IMPORT';
export const CSV_IMPORT_START_INPROGRESS = 'CSV_IMPORT_START_INPROGRESS';
export const CSV_IMPORT_START_DONE = 'CSV_IMPORT_START_DONE';
export const CSV_IMPORT_START_ERROR = 'CSV_IMPORT_START_ERROR';
export const CSV_IMPORT_STOP_INPROGRESS = 'CSV_IMPORT_STOP_INPROGRESS';
export const CSV_IMPORT_STOP_DONE = 'CSV_IMPORT_STOP_DONE';
export const CSV_IMPORT_STOP_ERROR = 'CSV_IMPORT_STOP_ERROR';

export const START_CSV_EXPORT = 'START_CSV_EXPORT';
export const CSV_EXPORT_START_INPROGRESS = 'CSV_EXPORT_START_INPROGRESS';
export const CSV_EXPORT_START_DONE = 'CSV_EXPORT_START_DONE';
export const CSV_EXPORT_START_ERROR = 'CSV_EXPORT_START_ERROR';

/** Simple form */
export const SIMPLE_FORM_FETCH_IN_PROGRESS = 'SIMPLE_FORM_FETCH_IN_PROGRESS';
export const SIMPLE_FORM_ERROR = 'SIMPLE_FORM_ERROR';
export const SIMPLE_FORM_SET_DATA = 'SIMPLE_FORM_SET_DATA';
export const SIMPLE_FORM_RESET_DATA = 'SIMPLE_FORM_RESET_DATA';

/**
 * Saga Type for Inventory Adjustment
 * @type {string}
 */
export const DELETE_INVENTORY_ADJUSTMENT = 'DELETE_INVENTORY_ADJUSTMENT';
export const DELETE_INVENTORY_ADJUSTMENT_FROM_LIST = 'DELETE_INVENTORY_ADJUSTMENT_FROM_LIST';
export const GET_INVENTORY_ADJUSTMENT = 'GET_INVENTORY_ADJUSTMENT';
export const FETCH_LIST_INVENTORY_ADJUSTMENT = 'FETCH_LIST_INVENTORY_ADJUSTMENT';
export const SAVE_INVENTORY_ADJUSTMENT = 'SAVE_INVENTORY_ADJUSTMENT';
export const GET_INVENTORY_ADJUSTMENT_LINE_ITEM_LOCATION = 'GET_INVENTORY_ADJUSTMENT_LINE_ITEM_LOCATION';
export const GET_ALL_INVENTORY_ADJUSTMENT_LINE_ITEM_LOCATION = 'GET_ALL_INVENTORY_ADJUSTMENT_LINE_ITEM_LOCATION';



/**
 * Saga Type for Inventory Stocktake
 * @type {string}
 */
export const DELETE_INVENTORY_STOCKTAKE = 'DELETE_INVENTORY_STOCKTAKE';
export const DELETE_INVENTORY_STOCKTAKE_FROM_LIST = 'DELETE_INVENTORY_STOCKTAKE_FROM_LIST';
export const GET_INVENTORY_STOCKTAKE = 'GET_INVENTORY_STOCKTAKE';
export const FETCH_LIST_INVENTORY_STOCKTAKE = 'FETCH_LIST_INVENTORY_STOCKTAKE';
export const SAVE_INVENTORY_STOCKTAKE = 'SAVE_INVENTORY_STOCKTAKE';
export const GET_INVENTORY_STOCKTAKE_ITEM_LOCATIONS = 'GET_INVENTORY_STOCKTAKE_ITEM_LOCATIONS';
export const EXPORT_STOCKTAKE_TO_DOC = 'EXPORT_STOCKTAKE_TO_DOC';

/**
 * Saga Type for Sale Transaction
 * @type {string}
 */
export const SAVE_SALE_TRANSACTION = 'SAVE_SALE_TRANSACTION';
export const FETCH_LIST_SALE_TRANSACTION = 'FETCH_LIST_SALE_TRANSACTION';
export const GET_SALE_TRANSACTION = 'GET_SALE_TRANSACTION';
export const EXPORT_EMAIL_SALE = 'EXPORT_EMAIL_SALE';
export const FETCH_SALE_TRANSACTION_INVENTORY = 'FETCH_SALE_TRANSACTION_INVENTORY';

/**
 * Saga Type for Purchase Order
 * @type {string}
 */
export const FETCH_LIST_PURCHASE_ORDER = 'FETCH_LIST_PURCHASE_ORDER';
export const GET_PURCHASE_ORDER = 'GET_PURCHASE_ORDER';
export const SAVE_PURCHASE_ORDER = 'SAVE_PURCHASE_ORDER';
export const GET_PURCHASE_ORDER_LINE_ITEM_LOCATION = 'GET_PURCHASE_ORDER_LINE_ITEM_LOCATION';
export const GET_PURCHASE_ORDER_LINE_TAX_GROUP = 'GET_PURCHASE_ORDER_LINE_TAX_GROUP';
export const GET_PURCHASE_ORDER_EXCHANGE_RATE = 'GET_PURCHASE_ORDER_EXCHANGE_RATE';
export const GET_ALL_PURCHASE_ORDER_LINES_ITEM_LOCATION = 'GET_ALL_PURCHASE_ORDER_LINES_ITEM_LOCATION';
export const GENERATE_PURCHASE_RECEIPT_DATA = 'GENERATE_PURCHASE_RECEIPT_DATA';
export const GET_PURCHASE_ORDER_REORDER = 'GET_PURCHASE_ORDER_REORDER';

/**
 * Saga Type for Purchase Receipt
 * @type {string}
 */
export const FETCH_LIST_PURCHASE_RECEIPT = 'FETCH_LIST_PURCHASE_RECEIPT';
export const GET_PURCHASE_RECEIPT = 'GET_PURCHASE_RECEIPT';
export const SAVE_PURCHASE_RECEIPT = 'SAVE_PURCHASE_RECEIPT';
export const GET_PURCHASE_RECEIPT_LINE_ITEM_LOCATION = 'GET_PURCHASE_RECEIPT_LINE_ITEM_LOCATION';
export const GET_ALL_PURCHASE_RECEIPT_LINES_ITEM_LOCATION = 'GET_ALL_PURCHASE_RECEIPT_LINES_ITEM_LOCATION';
export const GET_PURCHASE_RECEIPT_LINE_TAX_GROUP = 'GET_PURCHASE_RECEIPT_LINE_TAX_GROUP';
export const GET_PURCHASE_RECEIPT_EXCHANGE_RATE = 'GET_PURCHASE_RECEIPT_EXCHANGE_RATE';
export const GENERATE_PURCHASE_RETURN_DATA = 'GENERATE_PURCHASE_RETURN_DATA';

/**
 * Saga Type for Inventory return
 * @type {string}
 */
export const FETCH_LIST_INVENTORY_RETURN = 'FETCH_LIST_INVENTORY_RETURN';
export const GET_INVENTORY_RETURN = 'GET_INVENTORY_RETURN';
export const SAVE_INVENTORY_RETURN = 'SAVE_INVENTORY_RETURN';
export const GET_INVENTORY_RETURN_LINE_ITEM_LOCATION = 'GET_INVENTORY_RETURN_LINE_ITEM_LOCATION';
export const GET_ALL_INVENTORY_RETURN_LINES_ITEM_LOCATION = 'GET_ALL_INVENTORY_RETURN_LINES_ITEM_LOCATION';
export const GET_INVENTORY_RETURN_LINE_TAX_GROUP = 'GET_INVENTORY_RETURN_LINE_TAX_GROUP';
export const GET_INVENTORY_RETURN_EXCHANGE_RATE = 'GET_INVENTORY_RETURN_EXCHANGE_RATE';
export const EXPORT_EMAIL_INVENTORY_RETURN = 'EXPORT_EMAIL_INVENTORY_RETURN';


/**
 * Saga Type for Matrix child detail
 */
export const GENERATE_MATRIX_CHILDREN = 'GENERATE_MATRIX_CHILDREN';
export const CREATE_GENERATED_MATRIX_ITEMS = 'CREATE_GENERATED_MATRIX_ITEMS';


/**
 * Saga Type for Device
 */

export const DELETE_DEVICE = 'DELETE_DEVICE';
export const DELETE_DEVICE_FROM_LIST = 'DELETE_DEVICE_FROM_LIST';
export const FETCH_LIST_DEVICE = 'FETCH_LIST_DEVICE';
export const FETCH_DEVICE_BY_ID = 'FETCH_DEVICE_BY_ID';
export const SAVE_DEVICE = 'SAVE_DEVICE';


/**
 * Saga Type for Global search
 */

export const RESET_SEARCH_TERM = 'RESET_SEARCH_TERM';
export const SEARCH_TERM = 'SEARCH_TERM';
export const SEARCHING_TERM = 'SEARCHING_TERM';
export const DONE_SEARCHING_TERM = 'DONE_SEARCHING_TERM';
export const ERROR_SEARCHING_TERM = 'ERROR_SEARCHING_TERM';
export const FORCE_SHOW_RESULTS = 'FORCE_SHOW_RESULTS';


/**
 * Saga Type for Record
 */
export const FETCH_RECORD_TYPES = 'FETCH_RECORD_TYPES';
export const DONE_FETCH_RECORD_TYPES = 'DONE_FETCH_RECORD_TYPES';

export const FETCH_RECORD_FIELDS = 'FETCH_RECORD_FIELDS';
export const FETCHING_RECORD_FIELDS = 'FETCHING_RECORD_FIELDS';
export const DONE_FETCH_RECORD_FIELDS = 'DONE_FETCH_RECORD_FIELDS';

export const FETCH_RECORD_FIELD = 'FETCH_RECORD_FIELD';
export const FETCHING_RECORD_FIELD = 'FETCHING_RECORD_FIELD';
export const DONE_FETCH_RECORD_FIELD = 'DONE_FETCH_RECORD_FIELD';
export const ERROR_FETCH_RECORD_FIELD = 'ERROR_FETCH_RECORD_FIELD';


export const FETCH_RECORD_PREVIEW = 'FETCH_RECORD_PREVIEW';
export const FETCHING_RECORD_PREVIEW = 'FETCHING_RECORD_PREVIEW';
export const DONE_FETCH_RECORD_PREVIEW = 'DONE_FETCH_RECORD_PREVIEW';
export const FETCH_RECORD_PREVIEW_ERROR = 'FETCH_RECORD_PREVIEW_ERROR';

export const FETCHING_RECORD_EXPORT_HISTORY = 'FETCHING_RECORD_EXPORT_HISTORY';
export const DONE_FETCH_RECORD_EXPORT_HISTORY = 'DONE_FETCH_RECORD_EXPORT_HISTORY';

export const GO_BACK_RECORD = 'GO_BACK_RECORD';

/**
 * Saga Type for Payment Transaction
 */
 export const FETCH_LIST_PAYMENT_TRANSACTION = 'FETCH_LIST_PAYMENT_TRANSACTION';
 export const FETCH_PAYMENT_TRANSACTION_BY_ID = 'FETCH_PAYMENT_TRANSACTION_BY_ID';


/**
 * Saga Type for Credit Certificate
 */

export const FETCH_LIST_CREDIT_CERTIFICATE = 'FETCH_LIST_CREDIT_CERTIFICATE';
export const FETCH_CREDIT_CERTIFICATE_BY_ID = 'FETCH_CREDIT_CERTIFICATE_BY_ID';
export const SAVE_CREDIT_CERTIFICATE = 'SAVE_CREDIT_CERTIFICATE';
export const DELETE_CREDIT_CERTIFICATE = 'DELETE_CREDIT_CERTIFICATE';


export const ADD_BARCODE_TO_LIST = 'ADD_BARCODE_TO_LIST';
export const ADD_QRCODE_TO_LIST = 'ADD_QRCODE_TO_LIST';
export const FIND_MATCH_FOR_ITEM_VALUE = 'FIND_MATCH_FOR_ITEM_VALUE';


/**
 * Saga Type for Promotion
 */
export const DELETE_PROMOTION = 'DELETE_PROMOTION';
export const FETCH_PROMOTION_FOR_EDIT = 'FETCH_PROMOTION_FOR_EDIT';
export const FETCH_LIST_PROMOTION = 'FETCH_LIST_PROMOTION';
export const SAVE_PROMOTION = 'SAVE_PROMOTION';

export const FETCH_LIST_KAFKA_LOG = 'FETCH_LIST_KAFKA_LOG';
export const FETCH_KAFKA_LOG = 'FETCH_KAFKA_LOG';
export const SAVE_KAFKA_LOG = 'SAVE_KAFKA_LOG';

export const DELETE_LABEL_PRINT = 'DELETE_LABEL_PRINT';
export const FETCH_LIST_LABEL_PRINT = 'FETCH_LIST_LABEL_PRINT';
export const GET_LABEL_PRINT = 'GET_LABEL_PRINT';
export const PREVIEW_ITEM_LABEL_PRINT = 'PREVIEW_ITEM_LABEL_PRINT';
export const PRINT_LABEL_PRINT = 'PRINT_LABEL_PRINT';
export const PRINT_LABEL_PRINT_DONE = 'PRINT_LABEL_PRINT_DONE';
export const PRINT_LABEL_PRINT_ERROR = 'PRINT_LABEL_PRINT_ERROR';
export const PRINT_LABEL_PRINT_INPROGRESS = 'PRINT_LABEL_PRINT_INPROGRESS';
export const SAVE_LABEL_PRINT = 'SAVE_LABEL_PRINT';

export const EXPORT_PRINT_TRANSACTION = 'EXPORT_PRINT_TRANSACTION';
export const EXPORT_EMAIL_TRANSACTION = 'EXPORT_EMAIL_TRANSACTION';
